export default "__VITE_ASSET__DRnsWMCv__"